import axios from 'axios';

const HOSTAPI = process.env.REACT_APP_BASE_URL;

const UpdateMeetingStatus = async (payload: { isMeetingLive: boolean }, eventId: Number) => {
  try {
    const response = await axios.put(`${HOSTAPI}/events/${eventId}/status`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    return {
      status: error.response.status,
      data: error.response.data,
    };
  }
};

export default UpdateMeetingStatus;
